import styled from 'styled-components';

const ErrorHeader = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  letter-spacing: 0em;
  text-align: center;
  margin-bottom: 85px;
`;

export default ErrorHeader;
